const state = {
  isActive: false
};

const mutations = {
  setNavbarOpen() {
    state.isActive = true;
  },
  setNavbarClosed() {
    state.isActive = false;
  },
  setNavbarToggled() {
    state.isActive = !state.isActive;
  }
};

const actions = {
  closeNavbar({ commit }) {
    commit("setNavbarClosed");
  },
  openNavbar({ commit }) {
    commit("setNavbarOpen");
  },
  toggleNavbar({ commit }) {
    commit("setNavbarToggled");
  }
};

const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
